const routeList = [
  {
    path: "/jrcPolicy",
    name: "jrcPolicy",
    component: () => import("./policy/index.vue"),
  },
  {
    path: "/jsbrain",
    name: "jsbrain",
    component: () => import("./jsbrain/index.vue"),
  },
  {
    path: "/cdztjjsbrain",//中铁建 见山大脑
    name: "jsbrain",
    component: () => import("./cdztjjsbrain/index.vue"),
  },
  {
    path: "/jrcBrain",
    name: "jrcBrain",
    component: () => import("./jsbrain/index.vue"),
  },
  {
    path: "/jrcJiaoZiDaDao",
    name: "jrcJiaoZiDaDao",
    component: () => import("./jiaozi/index.vue"),
  },
  {
    path: "/jrcJsCerebrum",
    name: "jrcJsCerebrum",
    component: () => import("./jsCerebrum/index.vue"),
  },
  // {
  //     path: '/jrcIndustryDevelopment',
  //     name: "jrcIndustryDevelopment",
  //     component: () => import('./buildCricle/IndustryDevelopment.vue')
  // },
  {
    path: "/jrcBuildDetail",
    name: "jrcBuildDetail",
    component: () => import("./buildDetail/index.vue"),
  },
  {
    path: "/jrcCarbonManagement",
    name: "jrcCarbonManagement",
    component: () => import("./carbonManagement/index.vue"),
  },
  {
    path: "/jrcLookBuild", //点击楼宇弹窗
    name: "jrcLookBuild",
    component: () => import("./lookBuild/index.vue"),
  },
  {
    path: "/jrcEnergy", //能源管控
    name: "jrcEnergy",
    component: () => import("./energy/index.vue"),
  },
  {
    path: "/jrcBeidouPerception", //北斗感知
    name: "jrcBeidouPerception",
    component: () => import("./beidouPerception/index.vue"),
  },
  {
    path: "/jrcDeviceList", //设备管控
    name: "jrcDeviceList",
    component: () => import("./deviceList/index.vue"),
  },
  {
    path: "/jrcDeepChart", //地下官网 深度图表 872px*542px
    name: "jrcDeepChart",
    component: () => import("./undergroundNetwork/deepChart.vue"),
  },
  {
    path: "/jrcTypeChart", //地下官网 类型图表 872px*542px
    name: "jrcTypeChart",
    component: () => import("./undergroundNetwork/typeChart.vue"),
  },
  {
    path: "/jrcLandInfo", //地块信息
    name: "jrcLandInfo",
    component: () => import("./landInfo/index.vue"),
  },
  // {
  //     path: '/businessCircle',//交子商圈
  //     name: "businessCircle",
  //     component: () => import('./business/businessCircle/index.vue')
  // },
  {
    path: "/businessCircleCx", //春熙商圈
    name: "businessCircleCx",
    component: () => import("./businessCircleCx/businessCircle/index.vue"),
  },
  {
    path: "/businessDetail", //具体商场
    name: "businessDetail",
    component: () => import("./business/businessDetail/index.vue"),
  },
  {
    path: "/projectOverview", //项目概况
    name: "projectOverview",
    component: () => import("./project/projectOverview/index.vue"),
  },
  {
    path: "/projectBigEvent", //项目大事记
    name: "projectBigEvent",
    component: () => import("./project/projectBigEvent/index.vue"),
  },
  {
    path: "/documentManagement", //文档管理
    name: "documentManagement",
    component: () => import("./project/documentManagement/index.vue"),
  },
  {
    path: "/securityAwareness", //安全感知
    name: "securityAwareness",
    component: () => import("./project/securityAwareness/index.vue"),
  },
  {
    path: "/businessCircle", //交子商圈
    name: "jiaoziCircle",
    component: () => import("./jiaoziCircle/index.vue"),
  },
  {
    path: "/cricleContrast", //商圈对比
    name: "cricleContrast",
    component: () => import("./cricleContrast/index.vue"),
  },
  {
    path: "/jrcIndustryDevelopment", //金融城产业
    name: "jrcIndustry",
    component: () => import("./industry/IndustryDevelopment.vue"),
  },
  {
    path: "/jrcEnergyNew", //金融城楼宇管理
    name: "jrcEnergyNew",
    component: () => import("./energyNew/index.vue"),
  },
  {
    path: "/gante", //甘特图
    name: "gante",
    component: () => import("./gante/index.vue"),
  },
  {
    path: "/report", //报告
    name: "report",
    component: () => import("./report/index.vue"),
  },
  {
    path: "/phonereport", //手机端报告
    name: "phonereport",
    component: () => import("./phonereport/index.vue"),
  },
];
export default routeList;
